/**
 * What counts as one replyable address.
 *
 * `Name <a@b>` or a bare `a@b`. One address, never a list — a Reply-To with
 * two addresses splits every answer in two, and a display name with no angle
 * brackets is not an address at all.
 *
 * IN `shared` RATHER THAN `core` so the browser can apply the same rule the
 * server does. The deployment default, the per-tenant setting and the form
 * that edits it were three separate notions of "looks like an email"; the
 * deployment one was `opt()`, which accepted anything at all — including an
 * unsubstituted `$(SMTP_FROM)` from a variable group missing the key.
 */
export function isMailboxSpec(value: string): boolean {
  const v = (value ?? '').trim();
  if (v === '' || v.includes('$(')) return false;
  return /^(?:[^<>]*<\s*[^<>,\s]+@[^<>,\s]+\s*>|[^<>,\s]+@[^<>,\s]+)$/.test(v);
}
